import { KForm, KTextField } from "kinnect-general";

export default KForm.extend( {
	name: "KForgotPasswordForm",

	props: {
		formTitle: {
			...KForm.options.props.formTitle,
			default: "Forgot Password"
		},

		redirect: {
			...KForm.options.props.redirect,
			default: () => ( { name: "login" } )
		},

		submitButtonText: {
			...KForm.options.props.submitButtonText,
			default: "Send Email"
		},

		successMessage: {
			...KForm.options.props.successMessage,
			default: "We'll send you an email with further instructions for resetting your password."
		},

		successTimeout: {
			...KForm.options.props.successTimeout,
			default: 10000
		}
	},

	data: () => ( {
		formFields: {
			firstName: null,
			lastName: null
		},
		fullName: ""
	} ),

	watch: {
		fullName( fullName ) {
			if ( fullName ) {
				const splitName = fullName.trim().split( " " );

				this.formFields.firstName = splitName[0];
				this.formFields.lastName = splitName[1];
			} else {
				this.formFields.firstName = null;
				this.formFields.lastName = null;
			}
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: "auth/password/forgot",
				data: this.formFields,
				method: "post"
			}}
		>
			<p>After submitting this form, we'll send further instructions to the email address associated with your account.</p>

			<KTextField
				label="First and Last Name*"
				required
				vModel={this.fullName}
				validationName="name"
				validationRules="required|alpha_spaces|numberOfWords:2"
			></KTextField>
		</KForm>;
	}
} );
